/* esm.sh - d3-transition@3.0.1/src/transition/merge */
export * from "/*d3-transition@3.0.1/esnext/src/transition/merge.mjs";
export { default } from "/*d3-transition@3.0.1/esnext/src/transition/merge.mjs";
